/* Spirit Led Meta storefront tracking. Purchase belongs to verified payment integration. */
(()=>{
 'use strict';
 if(window.__spiritMetaInstalled)return;
 window.__spiritMetaInstalled=true;
 const ID='1717464009330544';
 const config=JSON.parse(document.getElementById('spirit-meta-config')?.textContent||'{}');
 let initialized=false,pageSent=false;
 function allowed(){const p=window.Shopify?.customerPrivacy;return !!(p?.marketingAllowed?.()&&p?.saleOfDataAllowed?.());}
 function start(){
  if(!allowed())return false;
  if(!initialized){
   if(!window.fbq){const q=window.fbq=function(){q.callMethod?q.callMethod.apply(q,arguments):q.queue.push(arguments);};if(!window._fbq)window._fbq=q;q.push=q;q.loaded=true;q.version='2.0';q.queue=[];const s=document.createElement('script');s.async=true;s.src='https://connect.facebook.net/en_US/fbevents.js';document.head.appendChild(s);}
   window.fbq('set','autoConfig',false,ID);
   window.fbq('init',ID);
   initialized=true;
  }
  return true;
 }
 function send(name,data){if(!start())return;window.fbq('trackSingle',ID,name,data||{},{eventID:'sl_'+(crypto.randomUUID?.()||Date.now()+'_'+Math.random().toString(36).slice(2))});}
 function page(){if(pageSent||!allowed())return;pageSent=true;send('PageView');if(config.product){const p=config.product;send('ViewContent',{content_type:'product',content_ids:[String(p.id)],contents:[{id:String(p.id),quantity:1}],value:p.price/100,currency:config.currency});}}
 document.addEventListener('visitorConsentCollected',page);
 if(window.Shopify?.customerPrivacy)page();
 else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)page();});
 // Only successful add responses count. Never fire on a click or a failed stock request.
 const originalFetch=window.fetch;
 window.fetch=async function(input,options){
  let added=[];
  try{
   let body=options?.body;
   if(!body&&typeof input?.clone==='function')body=await input.clone().text();
   if(typeof body==='string'){try{body=JSON.parse(body);}catch{body=new URLSearchParams(body);}}
   if(body?.get)added=[{id:String(body.get('id')),quantity:Number(body.get('quantity')||1)}];
   else if(body)added=(body.items||[body]).map(p=>({id:String(p.id),quantity:Number(p.quantity||1)}));
  }catch(_){}
  const response=await originalFetch.apply(this,arguments);
  try{
   const url=new URL(typeof input==='string'?input:input.url,location.href);
   const method=(options?.method||input?.method||'GET').toUpperCase();
   if(response.ok&&method==='POST'&&url.origin===location.origin&&/\/cart\/add(?:\.js)?$/.test(url.pathname)&&allowed()){
    response.clone().json().then(data=>{
     const items=data.items||[data];
     const contents=items.map(p=>{const requested=added.find(a=>a.id===String(p.variant_id||p.id));return requested&&p.product_id?{id:String(p.product_id),quantity:requested.quantity,item_price:(p.final_price??p.price)/100}:null;}).filter(p=>p&&p.quantity>0&&Number.isFinite(p.item_price));
     if(contents.length)send('AddToCart',{content_type:'product',content_ids:contents.map(p=>p.id),contents,value:Math.round(contents.reduce((n,p)=>n+p.item_price*p.quantity,0)*100)/100,currency:config.currency});
    }).catch(()=>{});
   }
  }catch(_){}
  return response;
 };
})();
